
import ToneModel from "../myComponents/ToneModel/ToneModel.vue"
import "./HelloFromVux.less";
import Chatframe from "../myComponents/Chatframe/Chatframe.vue";
import AddQa from "../myComponents/AddQa/AddQa.vue";
import SetThreeCom from "../myComponents/setThreeCom/setThreeCom.vue";
import VueSlickCarousel from "vue-slick-carousel";
import CharacterInsufficient from "../myComponents/characterInsufficient/characterInsufficient.vue"
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import AwaitReplyModel from "../myComponents/awaitReplyModel/awaitReplyModel.vue"
import EditTextModal from "../myComponents/EditTextModal/EditTextModal.vue"
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Countdown from 'vux/src/components/countdown/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Badge from 'vux/src/components/badge/index.vue'

import S51WebGLSDK from "../S51WebGLSDK";
import {
getVuxUrlQuery,
createRequest,
makeBase64,
getUrlParams,
} from "../utils/utils";
import "../../src/audio/js/record.js";
import { utils } from "../S51WebGLSDK/utils/utils";
import imgVoice from "../assets/voice.png";
import imgCostume from "../assets/costume.png";
import imgMic from "../assets/mic.png";
import imgMicLoad from "../assets/mic_load.png";
import imgRecording from "../assets/recording.png";
import imgPlay from "../assets/play.png";
import imgPlayActive from "../assets/play_active.png";
import { CHAT_EVNET, CHAT_MSG_TYPE } from "../S51WebGLSDK/define";
import QAComponent from "../myComponents/QAComponent/QAComponent.vue";
import { CHAT_ROLE, CHAT_TYPE } from "../myComponents/Chatframe";
import { STORAGE_KEY } from "../utils/define";
import HumanList from '../myComponents/HumanList/HumanList.vue';
import { headInfoSize, imageList, qaList, chatServiceStart, chatWordToVoice,setImage } from "../api/api";
import ChatInput from '../myComponents/ChatInput/ChatInput.vue';
import ThreeDsetPage from '@/components/SetQaPage'
import PaymentModel from '../myComponents/PaymentModel/PaymentModel.vue';
import PageVisible from '../myComponents/PageVisible/PageVisible.vue'
import { uploadQiniu } from "../qiniu";
import { BUS_EVENT, EventBus } from "../eventBus";
let recorder = null;
let param = getUrlParams(window.location.href);
export default {
showWebglStats: false,
components: {
XButton,
VueSlickCarousel,
Flexbox,
FlexboxItem,
XInput,
Group,
Loading,
Countdown,
InlineLoading,
Chatframe,
QAComponent,
AddQa,
Popup,
HumanList,
Badge,
ChatInput,
SetThreeCom,
PaymentModel,
AwaitReplyModel,
PageVisible,
CharacterInsufficient,
ToneModel,
EditTextModal
},
data() {
return {
msg: "Hello World!",
isLoading: false,
loadPercent: "0%",
settings: {
focusOnSelect: false,
infinite: false,
slidesToShow: 3,
slidesToScroll: 1,
speed: 120,
},
list: [],
clickCostumeId: 0,
modelViewId: 0,
value: "",
inputCostumeShow: false,
cutRecordState: false,
myChatVoiceBlob: undefined,
robotChatMessageType: "1", //内容类型
imageUrl: "/static/img/play_icon.png", //机器人回复图片地址
downloadUrl: "https://www.baidu.com/", //机器人回复下载查看地址
linkUrl: "https://www.baidu.com/", //机器人回复超链接地址
robotMessageTotal: "", //将要显示的所有聊天信息
robotChatDisplayIndex: 0,
chatTimeHandler: undefined, //聊天显示定时器
robotVoiceDuration: 0,

changeButtonText: "聊天",
imgVoiceUrl: imgVoice,
imgCostumeUrl: imgCostume,
imgMicUrl: imgMic,
imgMicLoadUrl: imgMicLoad,
imgRecordingUrl: imgRecording,
imgPlayUrl: imgPlay,
imgPlayActiveUrl: imgPlayActive,
playState: false,
movementList: [], //动作
voiceContentList: [












],
preComponentsState: "",
componentsState: "",//页面 ''-主页 costume-问答库 qa-新建问答 set-设置
fixationHeight: 1,
packUnfoldHeight: 0,
isDisplayDebug: false,
showDebug: false,
packUnfoldBlo: true,
packUnfoldState: true,
preinstallList: [],
virtualHumanGender: 0,
clothingShow: false,
clothingWhetherSelect: false,
clothingList: [],
debugInfo: {
modelID: 1,
errorMessage: "",
appID: "",
},
lastClickType: "",
addSaveRouter: 0,
spareList: [],
currentHumanName: '',
hasQAList: true,
hasSet: true,
isMyself: false,
curAppID: '',
purchaseModelIsopen: false,
isChatGPT: false,
imageType: 0,
awaitReply: false,
actionMaps: {},
defaultChatAction: '',
isHasConsume: false,
robberPurchase: false,
editStateIsOpen: false,
textareaValue: "",
firmId: 0, // 企业id,
closeShareImageState:false, //分享图的显示状态
activeEnableInput:true,
};
},
watch: {
value(value) {


},
voiceContentList(value) {
if (this.packUnfoldState) {
this.clothingShow = false
}

console.log("%c⧭", "color: #e57373", value);
},
clothingShow(val){
console.log('衣服选择隐藏:',val)
if(!val){ //衣服模态框隐藏 隐藏保存按钮，显示聊天框
this.packUnfoldBlo=true
this.clothingWhetherSelect=false
this.packUnfoldState=true
}
}
},
beforeRouteEnter(to, from, next) {
next(vm => {          //  这里的vm指的就是vue实例，可以用来当做this使用
console.log('-----------before router enter')
console.log(to)
console.log(from)

})
},
created() {

},
mounted() {


































console.log('route history', this.$router)
let param = utils.getUrlParams(window.location.href)
this.imageType = param.type == '3d' ? 1 : ''
console.log('%c⧭', 'color: #00a3cc', param)
S51WebGLSDK.initSDK(
document.querySelector(".top-box"),
0x616e75,
{
token: localStorage.getItem(STORAGE_KEY.TOKEN),
helper: param.helper
},
"development" == process.env.NODE_ENV
);

this.curPage = 0
this.isDisplayDebug = "development" == process.env.NODE_ENV

this.getCostume(localStorage.getItem(STORAGE_KEY.MODEL_ID), true).then(() => {
if (this.isMyself)
this.getImageList()
this.$forceUpdate()
})
qaList(localStorage.getItem(STORAGE_KEY.MODEL_ID), param.type).then(d => {
this.hasQAList = d.data.total > 0
})




window.addEventListener("popstate", function (e) {
console.log('回退事件', e)
}, false);


EventBus.$on(BUS_EVENT.ENABLE_INPUT, param => {
console.log('收到 enable input  消息',param)
this.activeEnableInput = param.enable
})

this.errorCount =0
EventBus.$on(BUS_EVENT.ADD_LOG, param => {
if(this.errorCount>=10){
this.debugInfo.errorMessage=""
}
this.debugInfo.errorMessage+= '\r\n'+param
this.errorCount++
})
},
beforeDestroy() {
console.log('beforeDestroy ')
S51WebGLSDK.stopNowVoice()
S51WebGLSDK.clearCache()
},
created() { },

methods: {

onCloseShareImage()
{
this.closeShareImageState = false
},

onPatternSetFinish(e) {
this.isChatGPT = e;
},

informEditModal(e) {
this.editStateIsOpen = e.open;
this.textareaValue = e.text
},
onCloseEditModal() {
this.editStateIsOpen = false;
},
onSaveEditTextModal(e) {
setImage({
image_id: this.modelViewId,
greet: e,
}).then(d => {
this.$vux.toast.show({
type: "text",
text: "保存成功",
});
this.editStateIsOpen = false;
this.$refs.myChatFrame.updateHelloWord(e)
}, e => {
console.error(e);
this.$vux.toast.show({
type: "text",
text: e,
});
})
},
onFreeOfCharge(e) {
this.robberPurchase = e;
},
onCharge(e) {
this.robberPurchase = false;
this.purchaseModelIsopen = true;
this.awaitReply = false;
},
onChatLeftNotEnough() {
if (this.isMyself) {
this.awaitReply = false;
this.robberPurchase = true;
}

},
debugClick() {
console.log('---debug click')
this.showWebglStats = !this.showWebglStats
S51WebGLSDK.showStats(this.showWebglStats)

if ("development" == process.env.NODE_ENV) {
this.showDebug = !this.showDebug
}

},
async getImageList() {
let res = await imageList()
this.spareList = res.data.data
},
onChatListChange(value) {
this.voiceContentList = value

if (!this.packUnfoldBlo) {
this.packUnfoldBlo = true
this.packUnfoldState = true
this.clothingShow = false
this.clothingWhetherSelect = false
}
},

onSaveVirtualHuman() {
if (this.isLoading || !this.activeEnableInput) {
return;
}

this.$vux.loading.show({
text: '正在保存形象'
})
S51WebGLSDK.downloadCanvasImg((err, blobData) => {
console.log('----截图', blobData)
if (err) {
this.$vux.loading.hide()
return this.$vux.toast.show({
type: 'text',
text: '形象保存失败，请重试'
})
}
let file = new File([blobData], 'screenshot.png', { type: 'image/png' })
uploadQiniu(file, 'png', (process) => {

}, (err, res) => {
console.log('上传', err, res)
if (err) {
this.$vux.loading.hide()
return this.$vux.toast.show({
type: 'text',
text: '形象保存失败，请重试'
})
}
setImage({
image_id: this.modelViewId,
show_clothes_id: this.clickCostumeId,
generate_cover: res.key
}).then(d => {
this.$vux.toast.show({
type: "text",
text: "保存成功",
});
this.$vux.loading.hide()
this.clothingShow = false;
this.clothingWhetherSelect = false;
}, e => {
console.error(e);
this.$vux.loading.hide()
this.$vux.toast.show({
type: "text",
text: e,
});
})
})
})

this.clothingWhetherSelect = false;
},

onPackUnfold() {
this.packUnfoldBlo = !this.packUnfoldBlo;
this.packUnfoldState = !this.packUnfoldState;
if (this.packUnfoldState) {//显示对话窗口则隐藏换装窗口
this.clothingShow = false
this.clothingWhetherSelect = false
}









},
openPDF() {





this.$wechat.miniProgram.navigateTo({
url: `../documentView/documentView?url=${encodeURIComponent('http://api.wangyi.talent666.top/assets/wangyi-tutorial.pdf')}`,
success: function () {
console.log('跳转成功')
}
})
},


showLoading() {
this.loadPercent = '0%'
this.isLoading = true;
},

closeLoading() {
console.log('loading finished')

this.loadPercent = "Loaded";
this.isLoading = false;


},

onCutInputButton() {
if (this.isLoading) {
return;
}
this.clickCostumeId = 0;
this.inputCostumeShow = !this.inputCostumeShow;
if (this.inputCostumeShow) {
this.changeButtonText = "换装";
} else {
this.changeButtonText = "聊天";
}
S51WebGLSDK.resetHumanPosition();
console.log("%c⧭", "color: #ff0000", 111);
},

onSelectCostume(item) {
if (this.isLoading || !this.activeEnableInput) {
return;
}
if (this.clickCostumeId == item.id) return;
this.clickCostumeId = item.id;
this.clothingWhetherSelect = true;
this.packUnfoldBlo=false
console.log("%c⧭", "color: #00e600", item);
this.showLoading();
S51WebGLSDK.loadAndCLoth(
item.file_glb,
(process) => {
this.loadPercent = `${Math.floor(process.percent)}%`;
},
(err, result) => {
if (err) {
console.error(err);
this.closeLoading();
} else {
this.closeLoading();
}
}
);
},


sendWord2Human(myChatMessage) {
this.awaitReply = true
this.$refs.myChatFrame.chat(CHAT_TYPE.TEXT, myChatMessage,this.cardID).then(
(d) => {
this.debugInfo.chatType = d.data.chat_type
this.debugInfo.word = d.data.word
if (this.isChatGPT) this.isHasConsume = true
},
(err) => { this.debugInfo.errorMessage = err; }
).finally(() => { this.awaitReply = false })
},
onInputEndRecordAudio(data) {
console.log('结束录音', data)
this.awaitReply = true
this.$refs.myChatFrame.chat(CHAT_TYPE.VOICE, {
voiceUrl: data.voiceUrl,
voiceSendData: data.voiceSendData,
voiceHttpUrl:data.voiceHttpUrl,
duration: data.duration
},this.cardID).then(
(d) => {

},
(err) => { this.debugInfo.errorMessage = err; }
).finally(() => { this.awaitReply = false })

},

getCostume(modelID) {
return new Promise((resolve, reject) => {
this.modelViewId = Number(modelID)
this.debugInfo.modelID = modelID

this.showLoading();
createRequest(
"get",
"applet/webview/model_view",
{ image_id: this.modelViewId },
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
document.title = res.data.image.name;
console.log("%c⧭", "color: #ffa640", res.data.clothes_map);
this.preinstallList = res.data.qa_list.data;
this.virtualHumanGender = res.data.app_info.gender;
this.clothingList = res.data.clothes_map;
this.clickCostumeId = res.data.image.show_clothes_id;
this.debugInfo.appID = res.data.app_info.app_id
this.curAppID = res.data.app_info.app_id
localStorage.setItem(STORAGE_KEY.MODEL_NAME, res.data.image.name)
this.isMyself = res.data.image.uid == res.data.uid
this.firmId = res.data.image.company_id;
let param = utils.getUrlParams(window.location.href)
this.cardID=param.cardId;
console.log('----------------------cardID',this.cardID)
chatServiceStart(res.data.app_info.app_id).then(prce => {
console.log('%c⧭', 'color: #ace2e6', prce)
if (prce.code == 500) {
chatServiceStart(res.data.app_info.app_id).then(val => {
console.log('%c⧭', 'color: #ace2e6', val)
})
}
})



console.log("%c⧭", "color: #997326", res.data.image.action_id, this.clickCostumeId);
S51WebGLSDK.resetAppID(res.data.app_info.app_id)
this.isChatGPT = res.data.image.chat_type == 2

this.currentHumanName = res.data.image.name
this.list = res.data.clothes_map;
this.hasSet = res.data.image.greet && res.data.image.greet != ''
let changeClothes = []
if (res.data.image.show_clothes_id) {
let cloth = res.data.clothes_map.find(ele => ele.id == res.data.image.show_clothes_id)
changeClothes = cloth ? cloth.file_glb : []
}
let actions = []
let chatActionMaps = new Map()
if (res.data.action_wait) {
actions.push(res.data.action_wait.fbx_url_qa)
chatActionMaps[res.data.action_wait.value] = res.data.action_wait.fbx_url_qa
}
if (res.data.action_interact) {
actions.push(res.data.action_interact.fbx_url_qa)
chatActionMaps[res.data.action_interact.value] = res.data.action_interact.fbx_url_qa
this.defaultChatAction = res.data.action_interact.value

}
let acionMap = res.data.action_map

console.log('acionMap', acionMap)
acionMap && acionMap && acionMap.forEach(action => {
actions.push(action.fbx_url)
chatActionMaps[action.value] = action.fbx_url_qa
})
this.actionMaps = chatActionMaps
let wordVoice
if (res.data.image.greet && res.data.image.greet.length > 0) {
chatWordToVoice(res.data.image.greet, this.curAppID).then((voiceRes) => {
if (res.code == 200) {
wordVoice = voiceRes.data
}
})
}



S51WebGLSDK.loadHuman(
res.data.image.model_url,

res.data.image.clothes_name_list,
res.data.hdr,
changeClothes,//默认需要替换的服装
actions, //所有需要提前加载的动作列表
res.data.action_wait.fbx_url,// 'https://ad-qiniu-demo.studio51.com/F_HuXi_V2.0.10.fbx',//空闲动作
{
gender: res.data.image.gender
},
(process) => {

if (process.percent >= 100) {


} else {
this.loadPercent = Math.floor(process.percent) + '%'
}
},
(err, result) => {

console.log(err, result, '123');
if (err) {
console.log('模型加载失败', err)
this.debugInfo.errorMessage = '模型加载失败:' + err
this.closeLoading();
this.$vux.toast.show({
type: "text",
text: '人物加载失败',
});
}
else {

if (res.data.image.greet && res.data.image.greet.length > 0) {

let start_ = Date.now()
let handler_ = setInterval(() => {
if (Date.now() - start_ > 5000) {
this.closeLoading();
return clearInterval(handler_)
}
if (wordVoice) {
this.closeLoading();
clearInterval(handler_)
this.sayHello(res.data.image.greet, wordVoice.audio, wordVoice.viseme, chatActionMaps[this.defaultChatAction], wordVoice.duration)
}
}, 500)

}
else{
this.closeLoading();
}

}

}
);
} else {

this.closeLoading();
console.error(res.msg);
this.$vux.toast.show({
type: "text",
text: res.msg,
});
}
resolve()
}
);
})

},
myMessagePlay(e) {
console.log("播放我的声音");
let _this = this;
if (this.myChatVoiceBlob) {
const audio = new Audio(
window.URL.createObjectURL(this.myChatVoiceBlob)
);
audio.play();
this.playState = true;
audio.addEventListener(
"ended",
function () {
console.log("%c⧭", "color: #731d1d", 111111);
_this.playState = false;
},
false
);
}
},
finish(index) {
this.onTouchend();

console.log("current index", index);
},

onCostumeModel(e) {
if (this.isLoading || !this.activeEnableInput) {
return;
}
this.clothingShow = !this.clothingShow;
this.$refs.myChatFrame.stopNowVoice()
},

onQaModel(e) {
if (this.isLoading || !this.activeEnableInput) {
return;
}
this.$router.push({
path: '/setQaPage',
query: { id: this.modelViewId, token: localStorage.getItem(STORAGE_KEY.TOKEN), image_show: 1, startPage: 'costume', type: '3d' }
});
},

onSetModel(e) {
this.closeShareImageState = true;





},
onUpChat() {
this.onSetModel()
},

onAddQuestions(event) {
this.switchPage('qa')
console.log("%c⧭", "color: #ffa640", this.componentsState);
},
onAQListChange(event) {
if (event.modelViewId == this.modelViewId) {
this.hasQAList == event.total > 0
}
},

onAddSaveRouter(event) {
this.switchPage(event)
this.addSaveRouter = this.addSaveRouter + 1;
console.log("%c⧭", "color: #ffa640", this.componentsState);
},

onSaveSetRouter(e) {
this.switchPage("")
if (e.modelViewId == this.modelViewId) {
this.hasSet = e.greet && e.greet.length
}
},

onCloseSetModel(e) {
this.switchPage("")
this.componentsState = ''



},
switchPage(page) {
this.preComponentsState = this.componentsState
this.componentsState = page;
console.log('switch page', page)
switch (page) {
case '':
document.title = this.currentHumanName

qaList(this.modelViewId).then(d => {
this.hasQAList = d.data.total > 0
})
break;
case 'costume':
case 'qa':
document.title = 'QA库'
break;
case 'set':
document.title = '设置'
break;

}
},
selectSpare(data) {
if (this.isLoading) {
return;
}


this.clothingShow = false;
this.getCostume(data.id).then(() => {

this.$refs.myChatFrame.clearChat()
})
},
onAddSpare() {
if (this.isLoading) {
return;
}
this.$wechat.miniProgram.navigateTo({
url: '../createFigure/createFigure',
success: function () {
console.log('跳转成功')
}
})
},
onBack(event) {
console.log('----back', event)
if (event == "home") {
this.switchPage("")
}
else {
this.switchPage(this.preComponentsState)
}

},
sendPreQuestion(question) {
console.log('发送预设问题:', question)


if (this.isLoading) {
return
}
this.awaitReply = true
this.$refs.myChatFrame.chat(CHAT_TYPE.TEXT, question.question,this.cardID).then(
d => {
if (this.isChatGPT) this.isHasConsume = true
},
err => { this.debugInfo.errorMessage = err }
).finally(() => {
this.awaitReply = false
})





















































},
sayHello(helloWord, helloAudio, helloVisem, action, duration) {
this.$refs.myChatFrame.sayHello(helloWord, helloAudio, helloVisem, action, duration, this.isMyself)

},
onInputWordSend(message) {
console.log('send message', message)
if (this.isLoading) {
return
}
if (!message || message.length == 0) {
return;
}
this.sendWord2Human(message)
},
onInputStartRecordAudio() {
console.log('开始录音')
S51WebGLSDK.stopNowVoice();
},


informCancelPurchase(e) {
this.purchaseModelIsopen = e;
},
informImmediatelyPurchase(e) {
if (e) {//充值成功
this.purchaseModelIsopen = false
this.$vux.toast.show({
type: "text",
text: "充值成功",
})
}

},
onOpenChargeModel() {
this.purchaseModelIsopen = true;
console.log('-----open charge')
}

},

};



// WEBPACK FOOTER //
// ./src/components/HelloFromVux.vue